import React from 'react';
import { Provider, observer } from 'mobx-react';

import Content from './Content';
import Centered from './Centered';
import Details from './Details';
import Name from './Name';
import AccountNumber from './AccountNumber';
import EditPencil from './EditPencil';

export const cardHeight = 8;

export default observer(({ bankAccount, onEdit, isBusy }) => (
  <Provider bankAccount={bankAccount}>
    <Details editor={!!onEdit} isBusy={isBusy} height={cardHeight}>
      <Centered>
        <Content>
          <Name>Bank Account</Name>
          <AccountNumber>
            {`#### #### #### ${bankAccount.number.slice(-4)}`}
          </AccountNumber>
        </Content>
      </Centered>
      {onEdit && <EditPencil onClick={onEdit} />}
    </Details>
  </Provider>
));
